<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.userpermission') }} > {{ $t('sidebar.all') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <base-table
        tableClass="table-bordered"
        hidePagination>
        <template #thead>
          <thead>
            <tr>
              <th style="width: 300px;">{{ $t('apps.settings.message.username') }}</th>
              <th>{{ $t('apps.settings.message.rolepermissions') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="isEmpty"
                colspan="2"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr v-for="(item, index) in empEmployees">
              <td>
                <router-link
                  :to="{
                    name: 'SettingsUserEdit',
                    query: {
                      id: item.emp_id,
                      username: item.username
                    }
                }">
                  {{ item.username }}
                </router-link>
              </td>
              <td>
                <span
                  v-for="(permission, index) in item.permissions"
                  :style="'margin-right: 5px;background:'+$t(getAppInfo(permission.app_id).translate + '.bgcolor')"
                  class="badge badge-secondary">
                  <i :class="$t(getAppInfo(permission.app_id).translate + '.icon')"/>
                  {{ $t(getAppInfo(permission.app_id).translate + '.title') }}
                </span>
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import sidebarModule from './../../sidebarModule'

export default {
  name: 'SettingsUserList',

  data () {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapGetters({
      employees: 'getEmployees',
      getAppInfo: 'getAppInfo',
    }),
    empEmployees () {
      return this.employees.map((item) => {
        const permissions = cloneDeep(item.permissions)
        return {
          ...item,
          permissions: permissions ? permissions.sort((a, b) => a.app_id - b.app_id) : [],
        }
      })
    },
    isEmpty () {
      return !this.employees.length
    },
  },

  created () {
    this.fetchData()
  },

  beforeMount: function () {
    this.initPage({
      section: 'app',
      name: this.$t('app.settings.title'),
      current: {
        app_name: 'settings',
        app_id: null,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 2,
      submenuAtIdx: 0,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, ['clearEmployees'])
  },

  methods: {
    ...mapActions({
      getEmployees: 'getEmployees',
    }),
    async fetchData () {
      this.loading = true
      await this.getEmployees()
      this.loading = false
      this.showFinish(this.$Progress)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/settings/user/List.vue